<template>
    <div>
        <div class="menu-item-left now-playing" :class="{hasCustomMix: selectedMix && selectedMix.id != 'auto', isTpg:isTpg}">
            <div v-if="isLoadingRemainingPlayers">
                <div class="spinner-container">
                    <div style="margin-top:0px;">
                        <div class="spinner black">
                            <div class="rect1"></div>
                            <div class="rect2"></div>
                            <div class="rect3"></div>
                            <div class="rect4"></div>
                            <div class="rect5"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="customMixHeader" v-if="selectedMix && selectedMix.id != 'auto'" :class="{isTpg:isTpg}">
                    Custom Mix: {{selectedMix.name}}
                </div>
                <div class="now-playing-image" v-if="selectedPlayer && selectedPlayer.isOnline() == true && selectedPlayer.isShutdown != '1'"  :class="{'has-mix': selectedMix && selectedMix.id != 'auto'}">
                    <img :src="trackCover" onerror="javascript:this.src='/images/unknown-album.jpg'" />
                    <div class="now-playing-image-overlay" :class="{isMuted: clientDidSetMuted == 1}" v-if="clientDidSetMuted == 1">
                        <div class="mute-button" title="Mute">
                            <span><div class="muted-volume-icon-dash" ></div>
                            <font-awesome-icon icon="times" class="vol-icon"  aria-hidden="false" /></span>
                        </div>
                    </div>
                </div>

                <div class="now-playing-track-info" v-if="selectedPlayer && selectedPlayer.isOnline() == true && selectedPlayer.isShutdown != '1'" :class="{'has-mix': selectedMix && selectedMix.id != 'auto'}">
                    <div class="now-playing-title">
                        {{ trackName }}
                    </div>
                    <div class="now-playing-artist">
                        {{ trackArtist }}
                    </div>
                    <div class="now-playing-label">
                        {{ trackLabel }}
                    </div>
                    <div class="now-playing-vote">
                        <div v-if="nowPlayingTrackWithVote && nowPlayingTrackWithVote.code">
                            <div class="vote-love" v-if="showVoteButtons() == true && itMode != true" id="voteLoveButton" v-on:click="voteClicked(nowPlayingTrackWithVote,1)" :class="{voteSelected: nowPlayingTrackWithVote.votes.vote == '1', isTpg:isTpg}"></div>
                            <div class="vote-leave" v-if="showVoteButtons() == true && itMode != true" id="voteLeaveButton" v-on:click="voteClicked(nowPlayingTrackWithVote,0)" :class="{voteSelected: nowPlayingTrackWithVote.votes.vote == '0', isTpg:isTpg}"></div>
                            <div v-if="canSkipTracks && nowPlayingTrackWithVote && nowPlayingTrackWithVote.code" class="skip-track" :class="{isTpg:isTpg}" v-on:click="skipTrack()" title="Skip Track"></div>
                            <div v-if="canCommentOnTracks" class="comment-icon-container">
                                <div class="now-playing-comment" v-on:click="popComment()" :class="{hasComment: nowPlayingTrackWithVote.votes.comment || nowPlayingTrackWithVote.votes.voteReasonId, isTpg:isTpg}">
                                </div>
                            </div>

                            <div v-if="shouldShowStationSwitcherButton" class="customMixEllipsis" :class="{ customMixListIsOpen: customMixListIsOpen, selectedMix:selectedMix.id != 'auto', isTpg:isTpg }" @click="toggleCustomMixList()" :title="'Currently playing: ' + selectedMix.name">
                                 <font-awesome-icon icon="ellipsis-h"  aria-hidden="false" />
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="selectedPlayer && selectedPlayer.isOnline() == false" class="playerOfflineText">
                    Your player is offline.<br />
                    Please contact us for help.
                </div>

                <div v-if="selectedPlayer && selectedPlayer.isShutdown == '1'" class="playerShutdownText">
                    This player is past due. <br />
                    Please contact us for help.
                </div>

            </div>

        </div>

    </div>

</template>

<script>

const Querystring = require('querystring');

export default {
  data() {
    return {
      slushLabels: ['General SoundExchange',
        'Beggars SoundExchange',
        'Sony SoundExchange',
        'Sony Review',
        'Sony Parent',
        'soundexchange',
        'review',
      ],
      customListServiceOptionId: 34,
      skippingServiceOptionId: 32,
      commentingServiceOptionId: 33
    };
  },
  props: ['user-info', 'now-playing-track-with-vote', 'selected-player', 'custom-mixes', 'selected-mix', 'custom-mix-list-is-open', 'is-tpg', 'client-did-set-muted', 'is-loading-remaining-players'],
  mounted() { },
  watch: {
    // userInfo: function() {
    //     var serviceOptions = this.userInfo.service_options;
    //     for (var i = 0; i < serviceOptions.length; i++) {
    //         if (serviceOptions[i].service_option_id == "16" || serviceOptions[i].service_option_id == 16) {
    //             this.itMode = true;
    //             return;
    //         }
    //     }
    // },
    nowPlayingTrackWithVote() {
      // console.log("nptwc " + this.nowPlayingTrackWithVote.name);
    },
  },
  methods: {
    popComment() {
      this.$emit('popNowPlayingComment');
    },
    /**
     * Skips current track
     *
     * @param int location_zone_player_id, string track_id
     * @return success
     */
    skipTrack() {
      this.$emit('skipTrack');

      const event_data = {
        web_tracking_event_type_id: 8,
        page_name: 'Menu - Now Playing',
        location_zone_id: this.selectedPlayer.locationZoneId,
        track_code: this.nowPlayingTrackWithVote.code,
      };
      this.$emit('logEvent', event_data);
    },
    /**
     * Handle vote click.
     *
     * T237 Modified (02-18-2022)
     *
     * @param object track, int loveOrLeave (love=1, leave=0)
     * @return this.makeVote()
     */
    voteClicked(track, loveOrLeave) {
      if (this.selectedPlayer && this.selectedPlayer != null) {
        // If already voted, delete first.
        if (track.votes.vote == '1' || track.votes.vote == '0') {
          const self = this;

          // WSL type - T686 (05-26-2022)
          if (this.selectedPlayer.playerTypeId == '4') {
            this.$http.delete(`/location_zone/vote/${this.selectedPlayer.fId()}/${track.code}`).then(() => {
              if (track.vote != loveOrLeave) {
                self.makeVote(track, loveOrLeave);
              } else {
                self.nowPlayingTrackWithVote.vote = null;
              }
            });
          } else { // All other Types (physical/virtual/instore)
            this.$http.delete(`/v3/vote/${this.selectedPlayer.playerTypeId}/${this.selectedPlayer.fId()}/${track.code}`).then(() => {
              if (track.votes.vote != loveOrLeave) {
                self.makeVote(track, loveOrLeave);
              } else {
                self.nowPlayingTrackWithVote.votes.vote = null;
              }
            });
          }
        } else {
          this.makeVote(track, loveOrLeave);
        }
      }

      const event_data = {
        web_tracking_event_type_id: 1,
        page_name: 'Menu - Now Playing',
        vote_value: loveOrLeave,
        track_code: track.code,
        location_zone_id: this.selectedPlayer.locationZoneId,
      };
      this.$emit('logEvent', event_data);
    },
    toggleCustomMixList() {
      this.$emit('toggleCustomMixer');
    },
    /**
     * Send POST API for vote.
     *
     * T237 Modified (02-18-2022)
     * T686 Modified (05-26-2022)
     *
     * @param object track, int loveOrLeave (love=1, leave=0)
     * @set this.nowPlayingTrackWithVote
     */
    makeVote(track, loveOrLeave) {
      let loveLeaveString = '';
      if (loveOrLeave == '1') {
        loveLeaveString = 'positive';
      } else if (loveOrLeave == '0') {
        loveLeaveString = 'negative';
      }

      this.$emit('logClicky', `/nowplaying-vote/${loveLeaveString}`);

      const self = this;

      // WSL type - T686 (05-26-2022)
      if (this.selectedPlayer.playerTypeId == '4') {
        const trackVote = Querystring.stringify({
          location_zone_player_id: this.selectedPlayer.fId(),
          overrideVoteType: loveLeaveString,
          station_code: this.selectedPlayer.stationCode,
          track_code: track.code
        });

        this.$http.post(`/v1/station/vote`, trackVote).then(() => {
          if (loveOrLeave == 1) {
            self.$wkToast("Got Your 'Love It' Vote");
          } else {
            self.$wkToast("We get it, you don't like this track.  No worries, now it's off your playlist.");
          }

          self.nowPlayingTrackWithVote.votes.vote = loveOrLeave;
        },
        (response) => {
          console.log(`Error on now playing makeVote() ${JSON.stringify(response)}`);
        });

      } else { // All other Types (physical/virtual/instore)
        const trackVote = Querystring.stringify({ overrideVoteType: loveLeaveString });

        this.$http.post(`/v3/vote/${this.selectedPlayer.playerTypeId}/${this.selectedPlayer.fId()}/${track.code}`, trackVote).then(() => {
          if (loveOrLeave == 1) {
            self.$wkToast("Got Your 'Love It' Vote");
          } else {
            self.$wkToast("We get it, you don't like this track.  No worries, now it's off your playlist.");
          }
          self.nowPlayingTrackWithVote.votes.vote = loveOrLeave;
        },
        (response) => {
          console.log(`Error on now playing makeVote() ${JSON.stringify(response)}`);
        });
      }
    },
    // getVote(nowPlayingTrack) { // TODO: NOT IN USE??? (02-17-2002)
    //   if (this.selectedLocationZone && this.selectedLocationZone != null) {
    //     const locationZoneID = this.selectedLocationZone.location_zone.id;
    //     const self = this;
    //     this.$http.get(`${'/v1/track-vote?' + 'code%5B%5D='}${nowPlayingTrack.code}&location_zone_id=${locationZoneID}`).then(function (response) {
    //       nowPlayingTrack.vote = response.data[0].vote;
    //       self.nowPlayingTrackWithVote = nowPlayingTrack;

    //       // EMIT NEW NOW PLAYIG TRACK
    //       if (nowPlayingTrack.code != self.oldTrackCode) {
    //         self.oldTrackCode = nowPlayingTrack.code;
    //         self.$emit('newTrack', this.nowPlayingTrackWithVote);
    //       }
    //     });
    //   }
    // },
    /**
     * Only show voting link if userInfo has serviceOption as Voting.
     *
     * @return true if service option true
     */
    showVoteButtons() {
      if (this.userInfo) {
        const serviceOptions = this.userInfo.service_options;
        if (serviceOptions) {
          for (let i = 0; i < serviceOptions.length; i++) {
            if (serviceOptions[i].service_option_id == '11' && serviceOptions[i].service_option_type_id == '3') {
              return true;
            }
          }
        }
      }

      return false;
    },
  },
  computed: {
    canSkipTracks() {
        const serviceOptions = this.userInfo.service_options;
        for (let i = 0; i < serviceOptions.length; i++) {
          if (serviceOptions[i].service_option_id == this.skippingServiceOptionId) {
            return true;
          }
        }

        return false;
    },
    canCommentOnTracks() {
        const serviceOptions = this.userInfo.service_options;
        for (let i = 0; i < serviceOptions.length; i++) {
          if (serviceOptions[i].service_option_id == this.commentingServiceOptionId) {
            return true;
          }
        }

        return false;
    },
    itMode() {
      const serviceOptions = this.userInfo.service_options;
      for (let i = 0; i < serviceOptions.length; i++) {
        if (serviceOptions[i].service_option_id == '16' || serviceOptions[i].service_option_id == 16) {
          return true;
        }
      }

      return false;
    },
    shouldShowStationSwitcherButton() {
      if (this.selectedMix && this.selectedPlayer && this.selectedPlayer.isPhysicalPlayer() && this.selectedPlayer.isShutdown !== '1' && this.customMixes.length > 0 && this.userHasCustomListServiceOption) {
        return true;
      }

      return false;
    },
    userHasCustomListServiceOption() {
      const serviceOptions = this.userInfo.service_options;
      for (let i = 0; i < serviceOptions.length; i++) {
        if (serviceOptions[i].service_option_id == this.customListServiceOptionId) {
          return true;
        }
      }

      return false;
    },
    trackCover() { // T232 - (01-14-2022)
      if (this.nowPlayingTrackWithVote && this.nowPlayingTrackWithVote.album.cover) {
        return this.nowPlayingTrackWithVote.album.cover;
      }
      return '/images/unknown-album.jpg';
    },
    trackLabel() {
      if (this.nowPlayingTrackWithVote && this.nowPlayingTrackWithVote.recordLabel && this.nowPlayingTrackWithVote.recordLabel.name) {
        let checkedLabel = this.nowPlayingTrackWithVote.recordLabel.name;
        if (this.slushLabels.indexOf(this.nowPlayingTrackWithVote.recordLabel.name) > -1) {
          checkedLabel = ' ';
        }
        return checkedLabel;
      }
      return '-';
    },
    trackArtist() {
      if (this.nowPlayingTrackWithVote && this.nowPlayingTrackWithVote.artist.name) {
        return this.nowPlayingTrackWithVote.artist.name;
      }
      return '-';
    },
    trackName() { // T232 - (01-14-2022)
      if (this.nowPlayingTrackWithVote && this.nowPlayingTrackWithVote.title) {
        return this.nowPlayingTrackWithVote.title;
      }

      return '-';
    },
    selectedPlayerTitle() {
      if(this.selectedPlayer.esTitle) {
        return this.selectedPlayer.esTitle;
      }

      if (this.selectedPlayer) {
        if (this.selectedPlayer.locationZoneName === 'Main' || this.selectedPlayer.locationZoneName === 'main') {
          return this.selectedPlayer.locationName;
        }
        return `${this.selectedPlayer.locationName} - ${this.selectedPlayer.locationZoneName}`;
      }
      return '-';
    },
    allowVoting() {
      if (this.userInfo && this.userInfo.service_options) {
        const serviceOptions = this.userInfo.service_options;
        for (let i = 0; i < serviceOptions.length; i++) {
          if (serviceOptions[i].service_option_name == 'Voting') {
            return true;
          }
        }
      }
      return false;
    },
  },
};

</script>

<style scoped>
.now-playing {
    height: 150px;/*auto;*/
}

.now-playing.hasCustomMix {
    height: auto;/*192px;*/ /*T369 08-29-2022 - resolves 'Last Tracks' label offset issue when custom mix is present in Safari*/
}

.now-playing-image {
    width: 120px;
    float: left;
    margin-top: 0px;
    position: relative;
    /* z-index: 10; */
}
.ow-playing-image.has-mix {
    margin-bottom:10px;
}
.now-playing-image img {
    height: 120px;
    width: 120px;
}

.now-playing-image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    background: #666;
    width: 100%;
    height: 100%;
    z-index: 11;
    opacity: 0;
}

.now-playing-image-overlay.isMuted {
    opacity: .7;
}

.now-playing-track-info {
    margin-top: 20px;
    width: 200px;
    padding-left: 10px;
    margin-left: 125px;
    padding-bottom: 2px;
}
.now-playing-track-info.has-mix {
    margin-top: 0px;
}
.now-playing-artist,
.now-playing-title,
.now-playing-label {
    font-size: 20px;
    height: 25px;
    line-height: 25px;
    text-align: left;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-bottom: 2px;
}

.customMixHeader {
    font-size: 18px;
    text-align: left;
    color: #BFBFBF;
    margin-top: -22px;
}
.customMixHeader.isTpg {
    color: black;
}
.now-playing-artist {
    font-size: 17px;
    opacity: .7;
}

.now-playing-label {
    font-size: 15px;
    opacity: .6;
    margin-top: -1px;
    height: 20px;
    line-height: 20px;
}

.unitIDContainer {
    font-size: 13px;
    color: #ccc;
    float: right;
    opacity: .8;
    width: 40px;
    margin-top: -27px;
    margin-right: 20px;
    text-align: right;
}

.onlineLight {
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background: green;
    float: right;
    margin-top: 16px;
    margin-left: 10px;
}

.offlinePlayer {
    background: #ccc;
}

.playerOfflineText {
    width: 70%;
    text-align: center;
    font-size: 14px;
    margin: 0 auto;
    height: 40px;
    line-height: 40px;
}

.playerShutdownText {
    width: 100%;
    text-align: center;
    font-size: 14px;
    margin: 0 auto;
    height: 100px;
    font-weight: bold;
    color: #de5454;
}

.customMixEllipsis {
    font-size: 14px;
    color: #ccc;
    float: right;
    width: 24px;
    height: 24px;
    cursor: pointer;
    margin-top: 20px;
    margin-right: -24px;
    text-align: center;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
    transition: all .1s ease;
    opacity: 1;
}

.customMixEllipsis.isTpg {
    color: black;
}

.customMixEllipsis.customMixListIsOpen {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
    opacity: 1;
}

@media (max-width: 768px) {
    .now-playing-artist,
    .now-playing-title {
        font-size: 15px;
        height: 16px;
        line-height: 16px;
    }
    .now-playing-title {
        padding-top: 0px;
        clear: right;
    }
    .now-playing-artist {
        margin-top: 5px;
    }
    /*    .now-playing-track-info {
        width:100%;
        margin-left:0px;
        padding-left: 0px;
    }*/
    .now-playing-track-info {
        margin-top: 0px;
        width: 200px;
        padding-left: 10px;
        margin-left: 60px;
    }
    .now-playing {
        height: 155px;
        margin-top: 10px;
    }
    .now-playing-vote {
        padding-top: 5px;
        width: 100%;
    }
    .now-playing-image {
        width: 60px;
    }
    .now-playing-image img {
        height: 60px;
        width: 60px;
    }
}

.skip-icon {
    margin-top: 1px;
    cursor: pointer;
    width: 26px;
    height: 26px;
    float: left;
    margin-right: 5px;
    padding: 0px;
    background-repeat: no-repeat;
    background-size: 100%;
}

.skip-icon {
    background: url("../../../assets/images/skipIcon.svg");
    background-repeat: no-repeat;
    background-size: 100%;
}

.comment-icon-container {
    position: relative;
    height: 34px;
    width: 34px;
    float: left;
}

.comment-glow {
    height: 22px;
    width: 22px;
    z-index: 0;
    position: relative;
    left: -0px;
    top: 3px;
    border-radius: 11px;
    transition: .5s;
}

.comment-glow.highlightComment {
    background: yellow;
    /*-webkit-transition:background-color 0.5s linear;*/
    /*-moz-transition: background-color 0.5s linear;*/
    /*-o-transition: background-color 0.5s linear;*/
    transition: .5s;
}

.comment-glow.highlightComment.isTpg {
    background: rgba(1, 172, 129, 1);
    /*-webkit-transition:background-color 0.5s linear;*/
    /*-moz-transition: background-color 0.5s linear;*/
    /*-o-transition: background-color 0.5s linear;*/
    transition: .5s;
}

.mute-button {
    height: 60px;
    margin: 0 auto;
    width: 60px;
    /*background:#4b4b4b;*/
    color: #ccc;
    border-radius: 30px;
    line-height: 40px;
    font-weight: bold;
    /*background:rgba(20,20,20,.8);*/
    margin-top: 10px;
    transition: .9s;
    border: 5px solid #414141;
    position: relative;
    margin-top: 30px;
}

.muted-volume-icon-dash {
    width: 52px;
    position: absolute;
    top: 22px;
    left: 0px;
    transform: rotate(48deg);
    height: 5px;
    background: #414141;
}

.vol-icon {
    font-size: 30px;
    margin-left: 12px;
    margin-top: 7px;
    color: #414141;
    opacity: .2;
}

.vote-love {
    margin-top: 15px;
}

.vote-love.voteSelected {
    margin-top: 18px;
}

.vote-love:hover {
    margin-top: 18px;
}

.vote-love.isTpg {
    margin-top: 18px;
}

.vote-love.isTpg.voteSelected {
    margin-top: 18px;
}

.vote-leave,
.vote-leave.voteSelected,
.vote-leave:hover,
.vote-leave.isTpg,
.vote-leave.isTpg.voteSelected,
.vote-leave.isTpg:hover {
    margin-top: 18px;
}

.skip-track,
.skip-track:hover,
.skip-track.isTpg:hover {
    margin-top: 18px;
}

.skip-track.isTpg:hover {
    margin-top: 22px;
}

.skip-track.isTpg {
    margin-top: 22px;
}

.now-playing-comment,
.now-playing-comment:hover,
.now-playing-comment.hasComment {
    margin-top: 10px;
}

.now-playing-comment.isTpg {
    margin-top: 18px;
}

.now-playing-comment.isTpg:hover,
.now-playing-comment.isTpg.hasComment {
    margin-top: 19px;
}

.spinner {
    margin: 10px auto;
    width: 45px;
    height: 35px;
    text-align: center;
    font-size: 8px;
}

.spinner>div {
    background-color: #ccc;
    height: 100%;
    width: 5px;
    display: inline-block;
    -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
    animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
}

.spinner .rect3 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
}

.spinner .rect4 {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
}

.spinner .rect5 {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
}

@-webkit-keyframes sk-stretchdelay {
    0%,
    40%,
    100% {
        -webkit-transform: scaleY(0.4)
    }
    20% {
        -webkit-transform: scaleY(1.0)
    }
}

@keyframes sk-stretchdelay {
    0%,
    40%,
    100% {
        transform: scaleY(0.4);
        -webkit-transform: scaleY(0.4);
    }
    20% {
        transform: scaleY(1.0);
        -webkit-transform: scaleY(1.0);
    }
}

/*.highlightComment {*/

/*-webkit-transition:background-color 0.5s linear;*/

/*-moz-transition: background-color 0.5s linear;*/

/*-o-transition: background-color 0.5s linear;*/

/*height: 20px;*/

/*width: 20px;*/

/*}*/
</style>
